module.exports = __webpack_public_path__ + "img/sphere11-graph-black.c9cf5af8.png";